import RapportsOrganisationProduitsController from './rapports.organisation.produits.controller';
import Template from './rapports.organisation.produits.html';

export default {
	controller: RapportsOrganisationProduitsController,
	template: Template
};
